export const getWorkerFile = (path: string) => {
  const url = new URL(path, import.meta.url).toString()
  return url
}
